module.exports = __webpack_public_path__ + "img/icon-skin.f2dfefbc.png";